import { Button, Flex, Text } from "@chakra-ui/react";

// images import
import Image from "next/image";
import successIcon from "../assets/success.svg";
import failureIcon from "../assets/failure.svg";

interface TransactionResult {
  status: string;
  message: string | null;
  openTransactionURL?: () => void;
  closeTransactionModal: () => void;
}

export const TransactionResult = ({
  status,
  openTransactionURL,
  closeTransactionModal,
  message,
}: TransactionResult) => {
  return (
    <Flex alignItems="center" flexDirection="column" pt="50px" pb="22px">
      <Image
        src={status === "SUCCESS" ? successIcon : failureIcon}
        width="67px"
        height="67px"
        alt=""
      />
      <Text mt="3.2rem" fontSize="1rem">
        {/* Transaction {status === "SUCCESS" ? "successful" : "failed"} */}
        {message}
      </Text>
      {openTransactionURL && status === "SUCCESS" && (
        <Button
          display="flex"
          mt="16px"
          mb="24px"
          onClick={
            status === "SUCCESS" ? openTransactionURL : closeTransactionModal
          }
          fontSize="14px"
          background="brand.primary"
          color="brand.textLight"
        >
          {status === "SUCCESS" ? "View Your Transactions" : "Please try again"}
        </Button>
      )}
      {status !== "SUCCESS" && (
        <Button
          display="flex"
          mt="16px"
          mb="24px"
          onClick={closeTransactionModal}
          fontSize="14px"
          background="brand.primary"
          color="brand.textLight"
        >
          Please try again
        </Button>
      )}
    </Flex>
  );
};
